let lockCount = 0;
let originalOverflow = "";

export function lockBodyScroll() {
  if (typeof document === "undefined") return;
  lockCount++;
  if (lockCount === 1) {
    originalOverflow = document.body.style.overflow || "";
    document.body.style.overflow = "hidden";
  }
}

export function unlockBodyScroll() {
  if (typeof document === "undefined") return;
  lockCount--;
  if (lockCount <= 0) {
    lockCount = 0;
    document.body.style.overflow = originalOverflow;
  }
}
